import { customer, EMR_BUILD_VERSION } from "./deploy_info";
import { resolveFirebaseConfig } from "./runtime-config";

export const environment = {
  production: true,
  version: EMR_BUILD_VERSION,
  customer,
  // Fallback used by `ng build` + Firebase Hosting deploys (no
  // assets/env.js override present). Ignored when the app is served from
  // the Docker image, which always injects a real config at container
  // start -- see resolveFirebaseConfig().
  firebaseConfig: resolveFirebaseConfig({
    apiKey: 'AIzaSyCKYZmZdb3EEnUWJ483vp4a8DHr3VQG1Jw',
    authDomain: 'calvin-emr.firebaseapp.com',
    projectId: 'calvin-emr',
    storageBucket: 'calvin-emr.appspot.com',
    messagingSenderId: '796970903777',
    appId: '1:796970903777:web:c5b2fbea226435a5f0afa0',
    measurementId: 'G-RKYF0QG1YN',
  }),
};
